import { render, staticRenderFns } from "./MenuFilterUsers.vue?vue&type=template&id=363c1de2"
import script from "./MenuFilterUsers.vue?vue&type=script&lang=js"
export * from "./MenuFilterUsers.vue?vue&type=script&lang=js"
import style0 from "./MenuFilterUsers.vue?vue&type=style&index=0&id=363c1de2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports